<template>
    <div
        class="widget"
        :class="{'nav-minimize': !!data.minimize}"
    >
        <div
            ref="persepectiveHolder"
            class="content-widget perspective-content"
            @click="antiScroll()"
        />
        <ScrollButton
            v-if="isWheelLocked"
            :toggleModeWheel="toggleModeWheel"
            :options="data"
        />
        <ThreeDController
            v-if="data.gui && data.gui.type === 'perspective'"
            :data="data"
            :widget="widget"
            :targetElement="targetElement"
        />
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import Http from '@/api/data';
    import { mapGetters } from 'vuex';

    import ThreeDController from "@/components/threeDController/ThreeDController";
    import ScrollButton from "@/components/ScrollButton";

    export default {
        name: 'Perspective',
        components: {
            ThreeDController,
            ScrollButton
        },
        props: [
            'data',
            'link',
            'active',
            'standalone'
        ],
        data () {
            return {
                isIE: false,
                targetElement: null,
                widget: null,
                toggleModeWheel: false,
            };
        },
        computed: {
            ...mapGetters([
                'isReviewUse',
                'protocol'
            ]),
            isWheelLocked() {
                return window.self !== window.top;
            },
            apiUrl() {
                return 'https://' + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            }
        },
        mounted() {
            this.isIE = window.navigator.msPointerEnabled;
            this.targetElement = this.$refs.persepectiveHolder;
            this.render();
        },
        methods: {
            callbacks() {
                return {
                    callbacks: {
                        widgetReadyCallback(widget) {
                            EventBus.$emit('widgetReady',widget);
                        }
                    }
                };
            },
            render() {
                let urlLink = this.$props.link ? this.$props.link : this.apiUrl + '/request-data/perspective' + window.location.search;
                if (this.language && !urlLink.includes('&language'))
                    urlLink += '&language=' + this.language;
                Http.getData(urlLink).then(payload => {
                     if (payload) {
                        payload.gui.type = 'perspective';
                        payload = Object.assign(payload, this.callbacks());
                        if (payload.language)
                            this.$i18n.locale = payload.language;
                        payload.isInternal = this.isInternal;
                        this.widget = new Habiteo.DigitalModelWidget(this.$refs.persepectiveHolder, payload);
                        EventBus.$emit('updateSidebar', payload, false);
                    }
                }).catch(error => {
                    EventBus.$emit('setErrorState', true, error);
                });
            },
            updateData() {
                let urlLink = this.$props.link ? this.$props.link : this.apiUrl + '/request-data/perspective' + window.location.search;
                if (this.language && !urlLink.includes('&language'))
                    urlLink += '&language=' + this.language;
                Http.getData(urlLink).then(payload => {
                     if (payload) {
                        payload.gui.type = 'perspective';
                        payload = Object.assign(payload, this.callbacks());
                        if (payload.language)
                            this.$i18n.locale = payload.language;
                        this.widget.loadData(payload);
                        EventBus.$emit('updateSidebar', payload, false);
                    }
                }).catch(error => {
                    EventBus.$emit('setErrorState', true, error);
                });
            },
            triggerResize() {
                if (this.isIE) {
                    let evt = window.document.createEvent('UIEvents');
                    evt.initUIEvent('resize', true, false, window, 0);
                    window.dispatchEvent(evt);
                } else
                    window.dispatchEvent(new Event('resize'));
            },
            antiScroll(){
                this.widget.unlockMouseWheel();
                this.toggleModeWheel = !this.toggleModeWheel;
            }
        },
        watch: {
            refresh() {
                this.triggerResize();
            },
            active(val) {
                if (val) {
                    this.updateData();
                    this.triggerResize();
                }
            }
        }
    };
</script>

<style lang="scss">
    .perspective-content{
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/views/PerspectiveWidget.vue